import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function contains(value) {
  return compareTo(value, this.e3()) >= 0 && compareTo(value, this.f3()) <= 0;
}
var ClosedRangeClass;
function ClosedRange() {
  if (ClosedRangeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ClosedRange');
    ClosedRangeClass = $;
  }
  return ClosedRangeClass;
}
//region block: exports
export {
  ClosedRange as ClosedRangehokgr73im9z3,
};
//endregion

//# sourceMappingURL=Range.mjs.map
